<style>
#ModellingError .v--modal-box.v--modal {
  min-height: 410px !important;
  min-width: 460px !important;
}
#ModellingError .modal__content {
  overflow-y: hidden !important;
}
#ModellingError .modal__footer {
  display: none;
}
</style>

<template>
  <Modal
    modalName="ModellingError"
    title="Raport błędu z modelowania"
    @closed="close"
    :buttons="[]"
  >
    <div class="wrapper">
      <v-subheader>Komunikat błędu</v-subheader>
      <p>{{errorMsg}}</p>
      <v-layout style="margin-top: 30px">
        <v-spacer/>
        <v-flex xs2>
          <v-btn @click="copyMsg" style="margin-right: 0" dark color="#2a579a">Skopiuj</v-btn>
        </v-flex>
      </v-layout>
    </div>
  </Modal>
</template>

<script>
import Modal from "../../../shared/Modal";

export default {
  components: {
    Modal
  },
  data: () => ({
    errorMsg: undefined
  }),
  computed: {},
  methods: {
    copyMsg() {
      const el = document.createElement("textarea");
      el.value = this.errorMsg;
      document.body.appendChild(el);
      el.select();
      document.execCommand("copy");
      document.body.removeChild(el);
      this.$root.$emit("showSnackbar", "#2a579a", "Skopiowano do schowka");
    },
    showModellingReport(report) {
      this.errorMsg = report;
    },
    close() {
      this.errorMsg = undefined;
    }
  },
  mounted() {
    this.$root.$on("showModellingReport", this.showModellingReport);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/viewer/modelWat/modals/ModellingError.vue